import React, { useState } from "react";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import DoctorConsult from "./DoctorConsult";
import LabTest from "../BillManagement/LabTest";

const Bills = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box
    // sx={{
    //   width: "100%",
    //   boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
    //   borderRadius: "16px",
    //   background: "linear-gradient(to bottom, #ffffff, #f6f9fc)",
    //   overflow: "hidden",
    // }}
    >
      <Box
      // sx={{
      //   padding: 4,
      //   textAlign: "center",
      //   backgroundColor: "#ffffff",
      //   boxShadow: "inset 0 -2px 10px rgba(0, 0, 0, 0.05)",
      //   borderBottomLeftRadius: "16px",
      //   borderBottomRightRadius: "16px",
      //   minHeight: "90vh",
      // }}
      >
        <LabTest />
      </Box>
      {/* <Tabs
        value={activeTab}
        onChange={handleTabChange}
        textColor="primary"
        indicatorColor="primary"
        variant="fullWidth"
        sx={{
          backgroundColor: "#e6e5e5",
          "& .MuiTab-root": {
            textTransform: "none",
            fontWeight: "600",
            fontSize: "16px",
            color: "#616161",
            "&:hover": {
              color: "#1976d2",
            },
          },
          "& .Mui-selected": {
            color: "#1976d2",
          },
          "& .MuiTabs-indicator": {
            height: "4px",
            borderRadius: "4px",
          },
        }}
      >
        <Tab label="Lab Test" />
        <Tab label="Doctor Consultation" />
      </Tabs>

      <Box
        sx={{
          padding: 4,
          textAlign: "center",
          backgroundColor: "#ffffff",
          boxShadow: "inset 0 -2px 10px rgba(0, 0, 0, 0.05)",
          borderBottomLeftRadius: "16px",
          borderBottomRightRadius: "16px",
          minHeight: "500px !important",
        }}
      >
        {activeTab === 0 && (
          <Box>
            <LabTest />
          </Box>
        )}
        {activeTab === 1 && (
          <Box>
            <DoctorConsult />
          </Box>
        )}
      </Box> */}
    </Box>
  );
};

export default Bills;
